import React, { FC } from 'react';
import { LangContext } from '../context';
import { useLangService } from '../service';

export const LangProvider: FC = ({ children }) => {
  const state = useLangService();

  return <LangContext.Provider value={state}>{children}</LangContext.Provider>;
};
